/**
 * Module definition houses utility implementation.
 *
 * @module stack.common.utility
 */
angular.module('stack.common.utility', [
  'stack.common.utility.services.StringService',
  'stack.common.utility.services.StorageService',
  'stack.common.utility.services.InterceptorService',
  'stack.common.utility.directive.ngRepeatFinish'
]);
